import React, { useState,useEffect } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { MDBCarousel, MDBCarouselItem } from 'mdb-react-ui-kit';

export default function Home() {
  // const [showModal, setShowModal] = useState(false);

  // const handleClose = () => setShowModal(false);
  // const handleShow = () => setShowModal(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState('');

  const handleClose = () => {
    setShowModal(false);
    setSelectedPackage('');
  };
  
  const handleShow = (packageTitle = '') => {
    setSelectedPackage(packageTitle);
    setShowModal(true);
  };


  const responsive = {
    superLargeDesktop: { breakpoint: { max: 4000, min: 3000 }, items: 5 },
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 3 },
    tablet: { breakpoint: { max: 1024, min: 600 }, items: 2 },
    mobile: { breakpoint: { max: 600, min: 0 }, items: 1 }
  };


  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://static.elfsight.com/platform/platform.js';
    script.async = true;
    document.body.appendChild(script);
    const hideElfsightFooter = () => {
      const links = document.querySelectorAll('a');
      links.forEach((link) => {
        if (
          link.href.includes('elfsight.com/google-reviews-widget') &&
          link.textContent.includes('Free Google Reviews widget')
        ) {
          link.style.display = 'none';
        }
      });
    };


    const initialTimer = setTimeout(() => {
      hideElfsightFooter();
    }, 3000);

    const observer = new MutationObserver(() => {
      hideElfsightFooter();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      document.body.removeChild(script);
      clearTimeout(initialTimer);
      observer.disconnect();
    };
  }, []);

  return (
    <div>
    <div className="hero-section position-relative" id="hero-sec">
      
      {/* Overlay Content */}
      

      {/* Background Slider */}
      <MDBCarousel showIndicators showControls fade className="background-carousel">
        <MDBCarouselItem itemId={1}>
          <img src="img/temple-5492094_1280.jpg" className="d-block w-100" alt="Slide 1" />
          <div className="overlay-content">
        <div className="overlay-inner-container">

          {/* Left Content */}
          <div className="left-content">
            <div className="top-img-rating mb-3 llllll">
              <img src="img/by20k.png" alt="Trust Badge" />
            </div>
            <h1 className="mb-3">Plan Your Utrakhand Tour Package</h1>
            <p>Experience Utrakhand like never before with <br/><span className='color-1'>Rizztourandtravels</span></p>
          </div>

          {/* Right Form */}
          <div className="form-container">
            <h2 className="mb-2">Talk To Our Expert</h2>
            <p className="mb-md-3 m-0">For Consultation on Utrakhand Holiday Packages!</p>
            <form method="POST" action="/best-tour-packages-in-india/mail.php">
            <div className="form-group mb-md-3 m-0">
              <label htmlFor="name">Full Name</label>
              <input type="text" id="name" name="name" required placeholder="Full Name" className="form-control" />
            </div>
            <div className="form-group mb-md-3 m-0">
              <label htmlFor="email">Email</label>
              <input type="email" id="email" name="email" required placeholder="Email" className="form-control" />
            </div>
            <div className="d-flex flex-row flex-md-row gap-2">
            <div className="form-group flex-fill">
              <label htmlFor="phone">Mobile</label>
              <input type="tel" id="phone" name="phone" required placeholder="Mobile" className="form-control" />
            </div>
              <div className="form-group flex-fill">
                <label htmlFor="nop">No of Persons</label>
                <input type="number" id="nop" name="nop" required placeholder="No of Persons" className="form-control" />
              </div>
              </div>
              <div className="d-flex flex-row flex-md-row gap-2 ">
              <div className="form-group flex-fill">
                <label htmlFor="travel_date">Travel Date</label>
                <input type="date" id="travel_date" name="travel_date" required placeholder="dd/mm/yyyy" className="form-control" />
              </div>
              <div className="form-group flex-fill">
                <label htmlFor="city">City</label>
                <input type="text" id="city" name="city" placeholder="City" required className="form-control" />
              </div>
            </div>
            <button type="submit" className="btn btn-primary w-100">Send Enquiry</button>
          </form>

          </div>

        </div>
      </div>
        </MDBCarouselItem>
        <MDBCarouselItem itemId={2}>
          <img src="img/mountain-6030438_1280.jpg" className="d-block w-100" alt="Slide 2" />
          <div className="overlay-content">
        <div className="overlay-inner-container">

          {/* Left Content */}
          <div className="left-content">
            <div className="top-img-rating mb-3 llllll">
              <img src="img/by20k.png" alt="Trust Badge" />
            </div>
            <h1 className="mb-3">Plan Your Himachal  Tour Package</h1>
            <p>Experience Himachal like never before with <br/><span className='color-1'>Rizztourandtravels</span></p>
          </div>

          {/* Right Form */}
          <div className="form-container">
            <h2 className="mb-2">Talk To Our Expert</h2>
            <p className="mb-md-3 m-0">For Consultation on Himachal Holiday Packages!</p>
            <form method="POST" action="/best-tour-packages-in-india/mail.php">
            <div className="form-group mb-md-3 m-0">
              <label htmlFor="name">Full Name</label>
              <input type="text" id="name" name="name" required placeholder="Full Name" className="form-control" />
            </div>
            <div className="form-group mb-md-3 m-0">
              <label htmlFor="email">Email</label>
              <input type="email" id="email" name="email" required placeholder="Email" className="form-control" />
            </div>
            <div className="d-flex flex-row flex-md-row gap-2">
            <div className="form-group flex-fill">
              <label htmlFor="phone">Mobile</label>
              <input type="tel" id="phone" name="phone" required placeholder="Mobile" className="form-control" />
            </div>
              <div className="form-group flex-fill">
                <label htmlFor="nop">No of Persons</label>
                <input type="number" id="nop" name="nop" required placeholder="No of Persons" className="form-control" />
              </div>
              </div>
              <div className="d-flex flex-row flex-md-row gap-2 ">
              <div className="form-group flex-fill">
                <label htmlFor="travel_date">Travel Date</label>
                <input type="date" id="travel_date" name="travel_date" required placeholder="dd/mm/yyyy" className="form-control" />
              </div>
              <div className="form-group flex-fill">
                <label htmlFor="city">City</label>
                <input type="text" id="city" name="city" placeholder="City" required className="form-control" />
              </div>
            </div>
            <button type="submit" className="btn btn-primary w-100">Send Enquiry</button>
          </form>

          </div>

        </div>
      </div>
        </MDBCarouselItem>
        <MDBCarouselItem itemId={3}>
          <img src="img/mountains-7729923_1280.jpg" className="d-block w-100" alt="Slide 3" />
          <div className="overlay-content">
        <div className="overlay-inner-container">

          {/* Left Content */}
          <div className="left-content">
            <div className="top-img-rating mb-3 llllll">
              <img src="img/by20k.png" alt="Trust Badge" />
            </div>
            <h1 className="mb-3">Plan Your Sikkim Tour Package</h1>
            <p>Experience Sikkim like never before with <br/><span className='color-1'>Rizztourandtravels</span></p>
          </div>

          {/* Right Form */}
          <div className="form-container">
            <h2 className="mb-2">Talk To Our Expert</h2>
            <p className="mb-md-3 m-0">For Consultation on sikkim Holiday Packages!</p>
            <form method="POST" action="/best-tour-packages-in-india/mail.php">
            <div className="form-group mb-md-3 m-0">
              <label htmlFor="name">Full Name</label>
              <input type="text" id="name" name="name" required placeholder="Full Name" className="form-control" />
            </div>
            <div className="form-group mb-md-3 m-0">
              <label htmlFor="email">Email</label>
              <input type="email" id="email" name="email" required placeholder="Email" className="form-control" />
            </div>
            <div className="d-flex flex-row flex-md-row gap-2">
            <div className="form-group flex-fill">
              <label htmlFor="phone">Mobile</label>
              <input type="tel" id="phone" name="phone" required placeholder="Mobile" className="form-control" />
            </div>
              <div className="form-group flex-fill">
                <label htmlFor="nop">No of Persons</label>
                <input type="number" id="nop" name="nop" required placeholder="No of Persons" className="form-control" />
              </div>
              </div>
              <div className="d-flex flex-row flex-md-row gap-2 ">
              <div className="form-group flex-fill">
                <label htmlFor="travel_date">Travel Date</label>
                <input type="date" id="travel_date" name="travel_date" required placeholder="dd/mm/yyyy" className="form-control" />
              </div>
              <div className="form-group flex-fill">
                <label htmlFor="city">City</label>
                <input type="text" id="city" name="city" placeholder="City" required className="form-control" />
              </div>
            </div>
            <button type="submit" className="btn btn-primary w-100">Send Enquiry</button>
          </form>

          </div>

        </div>
      </div>
        </MDBCarouselItem>
      </MDBCarousel>
    </div>
    <section className='about-sec m-4'>
        <div className='container '>
        <h2 className='text-center'>About Us</h2>
        <h6 className='text-center'>Experience Utrakhand like never before with<br/> <span className='color-1'>Rizztourandtravels</span></h6>
        <div className='row py-4 gy-4'>
          <div className='col-md-5 about-img-col'>
            <div className='about-img'>
              <img className='w-100 shadow' src="img/a13f94a8-16cf-4c8d-80d0-562e33d9d6f7.jpeg" alt='...'/>
            </div>
          </div>
          <div className='col-md-7'>
          <div className='about'>
                <p>The world is full of amazing places, diverse cultures, breath taking landscapes, oceans, lakes and forests full of wildlife.</p>
                <p>We at Rizz Tour and Travels are here to help you experience it all.</p>
                <p>RTT started as a small family business in 1993 and over the years has become one of the best Travel that caters to tourists all over the globe. Our friendly staff has extensive experience in travel industry with just one goal. We want to provide you with Legendary Service. Our staff goes above and beyond to make sure that every moment you spend with us becomes memorable for you.</p>
                <p>So whether you are newly wed couple who looking for honeymoon trip or adventure loving person who seeks thrill, or if you just want to get away with your loved ones from your daily routine. Rizz Tour and Travels has a perfect holiday package for you.</p>
                <p>Come and vacation with Rizz Tour and Travels, we will show you this world the way you have never seen it before.</p>
                <button className="enquire enquire-1" onClick={handleShow}>Enquiry Now</button>
            </div>
          </div>
        </div>
           
        </div>
    </section>
    
     <section className='best-package pt-4 pb-4'> 
        <div className='text-center package-title'>
            <h2>Uttarakhand Holiday Packages </h2>
            <h6>Experience Uttarakhand like never before with <br/><span className='color-1'>Rizztourandtravels</span></h6>
        </div>
        <div className='container pt-3'>
            <div className='row gy-4'>
            <div className='col-md-6 col-lg-4'>
                <div className="card">
                    <div className="relative">
                        <span className="tag">Best Selling Package
                          <span className='afb'></span>
                        </span>
                        <img className="main-img" src="img/istockphoto-1140128164-1024x1024.jpg" alt="Ladakh Tour" />
                        <div className="duration"><i className="fa-regular fa-clock me-2"></i> Duration: 05 Nights/06 days </div>
                    </div>
                    <div className="card-content">
                        <div className="title">Amazing Nainital & Corbett Mussorie </div>
                        <div className="places"><i className="fa-solid fa-location-dot me-2"></i>Places to visit Nainital, Mussoorie, Corbett, Kainchi Dham, Naini Lake, Eco cave Garden</div>
                        <hr/>
                        <div className="features">
                        <div><img src="img/binoculars_7006898.png" alt="Safety" />Sightseeing</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/hotel.webp" alt="Hotels" />Hotels</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/meal.webp" alt="Food" />Food</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/car.webp" alt="Transfers" />Transfers</div>
                        </div>
                        <hr/>
                        <div className="package-inclusion">
                        <h4>Package Inclusion:</h4>
                        <ul className="scrollable-list">
                          <li><i className="fa-solid fa-angles-right"></i>Hotel accommodation as per tour itinerary.</li>
                          <li><i className="fa-solid fa-angles-right"></i>06 Breakfast and 06 Dinner.</li>
                          <li><i className="fa-solid fa-angles-right"></i>Transportation by 26 seater Tempo Travellers from Delhi.</li>
                          <li><i className="fa-solid fa-angles-right"></i>Driver DA, fuel, parking and toll taxes.</li>
                          <li><i className="fa-solid fa-angles-right"></i> All currently applicable taxes.</li>
                        </ul>
                      </div>
                        <hr/>
                        <div className="price">
                        <span className='starts-from'>Starts from</span><br />
                        <span className="old">₹ 28,500</span> 
                        <span className="new">₹ 28,500</span><span>/Person ( Ex - Delhi )</span>
                        </div>

                        <div className="buttons">
                        <button
                        className="book"
                        onClick={() => window.open("https://wa.me/919796840001", "_blank")}
                      >
                         <i className="fab fa-whatsapp"></i>Whatsapp Now
                      </button>

                      <button
                        className="book"
                        onClick={() => (window.location.href = "tel:9796840001")}
                      ><i className="fas fa-phone-alt"></i> Call Now
                      </button>
                        <button className="enquire"  onClick={() => handleShow("Bond, Laugh, Explore: Kashmir Group Special – 5 Nights of Bliss")}><i className="fas fa-envelope"></i>Enquiry</button>
                        </div>
                    </div>
                    </div>
                </div>
                <div className='col-md-6 col-lg-4'>
                <div className="card">
                    <div className="relative">
                        <span className="tag">Best Selling Package
                          <span className='afb'></span>
                        </span>
                        <img className="main-img" src="img/download.jpeg" alt="Ladakh Tour" />
                        <div className="duration"><i className="fa-regular fa-clock me-2"></i> Duration: 4 Night 5 days</div>
                    </div>
                    <div className="card-content">
                        <div className="title"> Memorable Nainital & Corbett Vacay</div>
                        <div className="places"><i className="fa-solid fa-location-dot me-2"></i>Places to visit Nainital, Corbett, Kainchi Dham, Naini Lake, Eco cave Garden</div>
                        <hr/>
                        <div className="features">
                        <div><img src="img/binoculars_7006898.png" alt="Safety" />Sightseeing</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/hotel.webp" alt="Hotels" />Hotels</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/meal.webp" alt="Food" />Food</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/car.webp" alt="Transfers" />Transfers</div>
                        </div>
                        <hr/>
                        <div className="package-inclusion">
                        <h4>Package Inclusion:</h4>
                        <ul className="scrollable-list">
                          <li><i className="fa-solid fa-angles-right"></i>Pickup & Drop</li>
                          <li><i className="fa-solid fa-angles-right"></i>Food</li>
                          <li><i className="fa-solid fa-angles-right"></i>Sightseeing</li>
                          <li><i className="fa-solid fa-angles-right"></i>Private Cab</li>
                          <li><i className="fa-solid fa-angles-right"></i>Shikara Ride 
                       Houseboat stay in Dal Lake </li>
                        </ul>
                      </div>
                        <hr/>
                        <div className="price">
                        <span className='starts-from'>Starts from</span><br />
                        <span className="old">₹ 32,100</span> 
                        <span className="new">₹ 24,500 </span><span>/Person ( Ex - Delhi )</span>
                        </div>

                        <div className="buttons">
                        <button
                        className="book"
                        onClick={() => window.open("https://wa.me/919796840001", "_blank")}
                      >
                         <i className="fab fa-whatsapp"></i>Whatsapp Now
                      </button>

                      <button
                        className="book"
                        onClick={() => (window.location.href = "tel:9796840001")}
                      ><i className="fas fa-phone-alt"></i> Call Now
                      </button>
                        <button className="enquire" onClick={() => handleShow("Kashmir Unplugged: Beyond the Postcard : 6 Days Kashmir Offbeat")}><i className="fas fa-envelope"></i>Enquiry</button>
                        </div>
                    </div>
                    </div>
                </div>
                <div className='col-md-6 col-lg-4'>
                <div className="card">
                    <div className="relative">
                        <span className="tag">Best Selling Package
                          <span className='afb'></span>
                        </span>
                        <img className="main-img" src="img/images.jpeg" alt="Ladakh Tour" />
                        <div className="duration"><i className="fa-regular fa-clock me-2"></i> Duration: 4 Night 5 days</div>
                    </div>
                    <div className="card-content">
                        <div className="title">Romantic Kumaon with Wild Corbett & Nainita </div>
                        <div className="places"><i className="fa-solid fa-location-dot me-2"></i> Places to visit Nainital, Corbett, Kausani, Naini Lake, Sattal, Bhimtal, Baijnath Temple</div>
                        <hr/>
                        <div className="features">
                        <div><img src="img/binoculars_7006898.png" alt="Safety" />Sightseeing</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/hotel.webp" alt="Hotels" />Hotels</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/meal.webp" alt="Food" />Food</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/car.webp" alt="Transfers" />Transfers</div>
                        </div>
                        <hr/>
                        <div className="package-inclusion">
                        <h4>Package Inclusion:</h4>
                        <ul className="scrollable-list">
                          <li><i className="fa-solid fa-angles-right"></i>Pickup & Drop</li>
                          <li><i className="fa-solid fa-angles-right"></i>Jeep Safari</li>
                          <li><i className="fa-solid fa-angles-right"></i>Food</li>
                          <li><i className="fa-solid fa-angles-right"></i>Sightseeing</li>
                          <li><i className="fa-solid fa-angles-right"></i>Private Cab</li>
                          <li><i className="fa-solid fa-angles-right"></i> Shikara Ride 
                       Houseboat stay in Dal Lake </li>
                        </ul>
                      </div>
                        <hr/>
                        <div className="price">
                        <span className='starts-from'>Starts from</span><br />
                        <span className="old">₹ 26,000</span> 
                        <span className="new">₹ 34,500</span><span>/Person (Ex-Delhi)</span>
                        </div>

                        <div className="buttons">
                        <button
                        className="book"
                        onClick={() => window.open("https://wa.me/919796840001", "_blank")}
                      >
                         <i className="fab fa-whatsapp"></i>Whatsapp Now
                      </button>

                      <button
                        className="book"
                        onClick={() => (window.location.href = "tel:9796840001")}
                      ><i className="fas fa-phone-alt"></i> Call Now
                      </button>
                        <button className="enquire"onClick={() => handleShow("Wild, Wistful, and Untamed: The Kashmir You Didn't Know")}><i className="fas fa-envelope"></i>Enquiry</button>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section className='best-package pt-4 pb-4'> 
        <div className='text-center package-title'>
            <h2>Kerala Holiday Packages </h2>
            <h6>Experience Kerala like never before with <br/><span className='color-1'>Rizztourandtravels</span></h6>
        </div>
        <div className='container pt-3'>
            <div className='row gy-4'>
            <div className='col-md-6 col-lg-4'>
                <div className="card">
                    <div className="relative">
                        <span className="tag">Best Selling Package
                          <span className='afb'></span>
                        </span>
                        <img className="main-img" src="img/Kerala.jpeg" alt="Ladakh Tour" />
                        <div className="duration"><i className="fa-regular fa-clock me-2"></i> Duration: 5 Night 6 days</div>
                    </div>
                    <div className="card-content">
                        <div className="title">Honeymoon Gateway</div>
                        <div className="places"><i className="fa-solid fa-location-dot me-2"></i>Places to visit Cochin, Munnar, Thekkady</div>
                        <hr/>
                        <div className="features">
                        <div><img src="img/binoculars_7006898.png" alt="Safety" />Sightseeing</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/hotel.webp" alt="Hotels" />Hotels</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/meal.webp" alt="Food" />Food</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/car.webp" alt="Transfers" />Transfers</div>
                        </div>
                        <hr/>
                        <div className="package-inclusion">
                        <h4>Package Inclusion:</h4>
                        <ul className="scrollable-list">
                          <li><i className="fa-solid fa-angles-right"></i>Pickup & Drop</li>
                          <li><i className="fa-solid fa-angles-right"></i>Sightseeing</li>
                          <li><i className="fa-solid fa-angles-right"></i>Boating</li>
                          <li><i className="fa-solid fa-angles-right"></i>Photoshoot</li>
                          <li><i className="fa-solid fa-angles-right"></i>Candle Light Dinner</li>
                          <li><i className="fa-solid fa-angles-right"></i>Kathakali Dance Show</li>
                          <li><i className="fa-solid fa-angles-right"></i>Kerala Martial Arts Show</li>
                          <li><i className="fa-solid fa-angles-right"></i> Halfday Houseboat Tour</li>
                        </ul>
                      </div>
                        <hr/>
                        <div className="price">
                        <span className='starts-from'>Starts from</span><br />
                        <span className="old">₹ 28,500</span> 
                        <span className="new">₹ 32,500</span><span>/Person ( Ex - Kerala )</span>
                        </div>

                        <div className="buttons">
                        <button
                        className="book"
                        onClick={() => window.open("https://wa.me/919796840001", "_blank")}
                      >
                         <i className="fab fa-whatsapp"></i>Whatsapp Now
                      </button>

                      <button
                        className="book"
                        onClick={() => (window.location.href = "tel:9796840001")}
                      ><i className="fas fa-phone-alt"></i> Call Now
                      </button>
                        <button className="enquire"  onClick={() => handleShow("Bond, Laugh, Explore: Kashmir Group Special – 5 Nights of Bliss")}><i className="fas fa-envelope"></i>Enquiry</button>
                        </div>
                    </div>
                    </div>
                </div>
                <div className='col-md-6 col-lg-4'>
                <div className="card">
                    <div className="relative">
                        <span className="tag">Best Selling Package
                          <span className='afb'></span>
                        </span>
                        <img className="main-img" src="img/Kerala2.jpeg" alt="Ladakh Tour" />
                        <div className="duration"><i className="fa-regular fa-clock me-2"></i> Duration: 4 Night 5 days</div>
                    </div>
                    <div className="card-content">
                        <div className="title">Kerala Retreat</div>
                        <div className="places"><i className="fa-solid fa-location-dot me-2"></i> Places to visit Munnar, Thekkady, Alleppey,</div>
                        <hr/>
                        <div className="features">
                        <div><img src="img/binoculars_7006898.png" alt="Safety" />Sightseeing</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/hotel.webp" alt="Hotels" />Hotels</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/meal.webp" alt="Food" />Food</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/car.webp" alt="Transfers" />Transfers</div>
                        </div>
                        <hr/>
                        <div className="package-inclusion">
                        <h4>Package Inclusion:</h4>
                        <ul className="scrollable-list">
                          <li><i className="fa-solid fa-angles-right"></i>Pickup & Drop</li>
                          <li><i className="fa-solid fa-angles-right"></i>Sightseeing</li>
                          <li><i className="fa-solid fa-angles-right"></i>Boating at Periyar Lake</li>
                          <li><i className="fa-solid fa-angles-right"></i>Kathakali Dance Show</li>
                          <li><i className="fa-solid fa-angles-right"></i>Kerala Martial Arts Show </li>
                        </ul>
                      </div>
                        <hr/>
                        <div className="price">
                        <span className='starts-from'>Starts from</span><br />
                        <span className="old">₹ 32,100</span> 
                        <span className="new">₹ 17,400</span><span>/Person ( Ex -Kerala )</span>
                        </div>

                        <div className="buttons">
                        <button
                        className="book"
                        onClick={() => window.open("https://wa.me/919796840001", "_blank")}
                      >
                         <i className="fab fa-whatsapp"></i>Whatsapp Now
                      </button>

                      <button
                        className="book"
                        onClick={() => (window.location.href = "tel:9796840001")}
                      ><i className="fas fa-phone-alt"></i> Call Now
                      </button>
                        <button className="enquire" onClick={() => handleShow("Kashmir Unplugged: Beyond the Postcard : 6 Days Kashmir Offbeat")}><i className="fas fa-envelope"></i>Enquiry</button>
                        </div>
                    </div>
                    </div>
                </div>
                <div className='col-md-6 col-lg-4'>
                <div className="card">
                    <div className="relative">
                        <span className="tag">Best Selling Package
                          <span className='afb'></span>
                        </span>
                        <img className="main-img" src="img/Kerala3.jpeg" alt="Ladakh Tour" />
                        <div className="duration"><i className="fa-regular fa-clock me-2"></i> Duration: 3 Night 4 days</div>
                    </div>
                    <div className="card-content">
                        <div className="title"> Most Wanted Kerala </div>
                        <div className="places"><i className="fa-solid fa-location-dot me-2"></i> Places to visit Munnar, Alleppey</div>
                        <hr/>
                        <div className="features">
                        <div><img src="img/binoculars_7006898.png" alt="Safety" />Sightseeing</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/hotel.webp" alt="Hotels" />Hotels</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/meal.webp" alt="Food" />Food</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/car.webp" alt="Transfers" />Transfers</div>
                        </div>
                        <hr/>
                        <div className="package-inclusion">
                        <h4>Package Inclusion:</h4>
                        <ul className="scrollable-list">
                          <li><i className="fa-solid fa-angles-right"></i>Pickup & Drop</li>
                          <li><i className="fa-solid fa-angles-right"></i>Food</li>
                          <li><i className="fa-solid fa-angles-right"></i>Sightseeing</li>
                          <li><i className="fa-solid fa-angles-right"></i>Boating at Periyar Lake</li>
                          <li><i className="fa-solid fa-angles-right"></i> Half-day Houseboat Tour</li>
                        </ul>
                      </div>
                        <hr/>
                        <div className="price">
                        <span className='starts-from'>Starts from</span><br />
                        <span className="old">₹ 26,000</span> 
                        <span className="new">₹ 14,400</span><span>/Person (Kerala)</span>
                        </div>

                        <div className="buttons">
                        <button
                        className="book"
                        onClick={() => window.open("https://wa.me/919796840001", "_blank")}
                      >
                         <i className="fab fa-whatsapp"></i>Whatsapp Now
                      </button>

                      <button
                        className="book"
                        onClick={() => (window.location.href = "tel:9796840001")}
                      ><i className="fas fa-phone-alt"></i> Call Now
                      </button>
                        <button className="enquire"onClick={() => handleShow("Wild, Wistful, and Untamed: The Kashmir You Didn't Know")}><i className="fas fa-envelope"></i>Enquiry</button>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section className='best-package pt-4 pb-4'> 
        <div className='text-center package-title'>
            <h2>Darjeeling Holiday Packages </h2>
            <h6>Experience Darjeeling like never before with <br/><span className='color-1'>Rizztourandtravels</span></h6>
        </div>
        <div className='container pt-3'>
            <div className='row gy-4'>
            <div className='col-md-6 col-lg-4'>
                <div className="card">
                    <div className="relative">
                        <span className="tag">Best Selling Package
                          <span className='afb'></span>
                        </span>
                        <img className="main-img" src="img/Darjeeling.jpeg" alt="Ladakh Tour" />
                        <div className="duration"><i className="fa-regular fa-clock me-2"></i> Duration: 5 Night 6 days</div>
                    </div>
                    <div className="card-content">
                        <div className="title">Bond, Laugh, Explore: Darjeeling Group Special – 5 Nights of Bliss</div>
                        <div className="places"><i className="fa-solid fa-location-dot me-2"></i> Srinagar(3N) | Gulmarg Day Trip | Sonmarg (1N)</div>
                        <hr/>
                        <div className="features">
                        <div><img src="img/binoculars_7006898.png" alt="Safety" />Sightseeing</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/hotel.webp" alt="Hotels" />Hotels</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/meal.webp" alt="Food" />Food</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/car.webp" alt="Transfers" />Transfers</div>
                        </div>
                        <hr/>
                        <div className="package-inclusion">
                        <h4>Package Inclusion:</h4>
                        <ul className="scrollable-list">
                          <li><i className="fa-solid fa-angles-right"></i>Pickup & Drop</li>
                          <li><i className="fa-solid fa-angles-right"></i>Food</li>
                          <li><i className="fa-solid fa-angles-right"></i>Sightseeing</li>
                          <li><i className="fa-solid fa-angles-right"></i>Private Cab</li>
                          <li><i className="fa-solid fa-angles-right"></i>Shikara Ride 
                          Houseboat stay in Dal Lake</li>
                        </ul>
                      </div>
                        <hr/>
                        <div className="price">
                        <span className='starts-from'>Starts from</span><br />
                        <span className="old">₹ 28,500</span> 
                        <span className="new">₹ 24,000</span><span>/Person ( Ex - Darjeeling )</span>
                        </div>

                        <div className="buttons">
                        <button
                        className="book"
                        onClick={() => window.open("https://wa.me/919796840001", "_blank")}
                      >
                         <i className="fab fa-whatsapp"></i>Whatsapp Now
                      </button>

                      <button
                        className="book"
                        onClick={() => (window.location.href = "tel:9796840001")}
                      ><i className="fas fa-phone-alt"></i> Call Now
                      </button>
                        <button className="enquire"  onClick={() => handleShow("Bond, Laugh, Explore: Kashmir Group Special – 5 Nights of Bliss")}><i className="fas fa-envelope"></i>Enquiry</button>
                        </div>
                    </div>
                    </div>
                </div>
                <div className='col-md-6 col-lg-4'>
                <div className="card">
                    <div className="relative">
                        <span className="tag">Best Selling Package
                          <span className='afb'></span>
                        </span>
                        <img className="main-img" src="img/Darjeeling1.jpeg" alt="Ladakh Tour" />
                        <div className="duration"><i className="fa-regular fa-clock me-2"></i> Duration: 5 Night 6 days</div>
                    </div>
                    <div className="card-content">
                        <div className="title">Darjeeling Unplugged: Beyond the Postcard : 6 Days Darjeeling Offbeat </div>
                        <div className="places"><i className="fa-solid fa-location-dot me-2"></i> Srinagar(2N) | Wular Lake (1N) | Gurez Valley (5N)</div>
                        <hr/>
                        <div className="features">
                        <div><img src="img/binoculars_7006898.png" alt="Safety" />Sightseeing</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/hotel.webp" alt="Hotels" />Hotels</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/meal.webp" alt="Food" />Food</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/car.webp" alt="Transfers" />Transfers</div>
                        </div>
                        <hr/>
                        <div className="package-inclusion">
                        <h4>Package Inclusion:</h4>
                        <ul className="scrollable-list">
                          <li><i className="fa-solid fa-angles-right"></i>Pickup & Drop</li>
                          <li><i className="fa-solid fa-angles-right"></i>Food</li>
                          <li><i className="fa-solid fa-angles-right"></i>Sightseeing</li>
                          <li><i className="fa-solid fa-angles-right"></i>Private Cab</li>
                          <li><i className="fa-solid fa-angles-right"></i>Shikara Ride 
                       Houseboat stay in Dal Lake </li>
                        </ul>
                      </div>
                        <hr/>
                        <div className="price">
                        <span className='starts-from'>Starts from</span><br />
                        <span className="old">₹ 32,100</span> 
                        <span className="new">₹ 29,600</span><span>/Person ( Ex - Darjeeling )</span>
                        </div>

                        <div className="buttons">
                        <button
                        className="book"
                        onClick={() => window.open("https://wa.me/919796840001", "_blank")}
                      >
                         <i className="fab fa-whatsapp"></i>Whatsapp Now
                      </button>

                      <button
                        className="book"
                        onClick={() => (window.location.href = "tel:9796840001")}
                      ><i className="fas fa-phone-alt"></i> Call Now
                      </button>
                        <button className="enquire" onClick={() => handleShow("Kashmir Unplugged: Beyond the Postcard : 6 Days Kashmir Offbeat")}><i className="fas fa-envelope"></i>Enquiry</button>
                        </div>
                    </div>
                    </div>
                </div>
                <div className='col-md-6 col-lg-4'>
                <div className="card">
                    <div className="relative">
                        <span className="tag">Best Selling Package
                          <span className='afb'></span>
                        </span>
                        <img className="main-img" src="img/Darjeeling3.jpeg" alt="Ladakh Tour" />
                        <div className="duration"><i className="fa-regular fa-clock me-2"></i> Duration: 7 Night 8 days</div>
                    </div>
                    <div className="card-content">
                        <div className="title"> The Darjeeling You Didn’t Know </div>
                        <div className="places"><i className="fa-solid fa-location-dot me-2"></i> Srinagar(6N) | Kokernag (1N) | Ahrabal Day trip | Yusmarg day trip | Bangus Valley day trip | Verinag & Achabal  Day trip | 
                        </div>
                        <hr/>
                        <div className="features">
                        <div><img src="img/binoculars_7006898.png" alt="Safety" />Sightseeing</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/hotel.webp" alt="Hotels" />Hotels</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/meal.webp" alt="Food" />Food</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/car.webp" alt="Transfers" />Transfers</div>
                        </div>
                        <hr/>
                        <div className="package-inclusion">
                        <h4>Package Inclusion:</h4>
                        <ul className="scrollable-list">
                          <li><i className="fa-solid fa-angles-right"></i>Pickup & Drop</li>
                          <li><i className="fa-solid fa-angles-right"></i>Food</li>
                          <li><i className="fa-solid fa-angles-right"></i>Sightseeing</li>
                          <li><i className="fa-solid fa-angles-right"></i>Private Cab</li>
                          <li><i className="fa-solid fa-angles-right"></i> Shikara Ride 
                       Houseboat stay in Dal Lake </li>
                        </ul>
                      </div>
                        <hr/>
                        <div className="price">
                        <span className='starts-from'>Starts from</span><br />
                        <span className="old">₹ 26,000</span> 
                        <span className="new">₹ 24,000</span><span>/Person (Darjeeling)</span>
                        </div>

                        <div className="buttons">
                        <button
                        className="book"
                        onClick={() => window.open("https://wa.me/919796840001", "_blank")}
                      >
                         <i className="fab fa-whatsapp"></i>Whatsapp Now
                      </button>

                      <button
                        className="book"
                        onClick={() => (window.location.href = "tel:9796840001")}
                      ><i className="fas fa-phone-alt"></i> Call Now
                      </button>
                        <button className="enquire"onClick={() => handleShow("Wild, Wistful, and Untamed: The Kashmir You Didn't Know")}><i className="fas fa-envelope"></i>Enquiry</button>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section className='best-package pt-4 pb-4'> 
        <div className='text-center package-title'>
            <h2>sikkim Holiday Packages </h2>
            <h6>Experience sikkim like never before with <br/><span className='color-1'>Rizztourandtravels</span></h6>
        </div>
        <div className='container pt-3'>
            <div className='row gy-4'>
            <div className='col-md-6 col-lg-4'>
                <div className="card">
                    <div className="relative">
                        <span className="tag">Best Selling Package
                          <span className='afb'></span>
                        </span>
                        <img className="main-img" src="img/photo-1647438193740-64016bbaf6e5.avif" alt="Ladakh Tour" />
                        <div className="duration"><i className="fa-regular fa-clock me-2"></i> Duration: 5 Night 6 days</div>
                    </div>
                    <div className="card-content">
                        <div className="title">Gangtok Tour</div>
                        <div className="places"><i className="fa-solid fa-location-dot me-2"></i> Srinagar(3N) | Gulmarg Day Trip | Sonmarg (1N)</div>
                        <hr/>
                        <div className="features">
                        <div><img src="img/binoculars_7006898.png" alt="Safety" />Sightseeing</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/hotel.webp" alt="Hotels" />Hotels</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/meal.webp" alt="Food" />Food</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/car.webp" alt="Transfers" />Transfers</div>
                        </div>
                        <hr/>
                        <div className="package-inclusion">
                        <h4>Package Inclusion:</h4>
                        <ul className="scrollable-list">
                          <li><i className="fa-solid fa-angles-right"></i>Pickup & Drop</li>
                          <li><i className="fa-solid fa-angles-right"></i>Food</li>
                          <li><i className="fa-solid fa-angles-right"></i>Sightseeing</li>
                          <li><i className="fa-solid fa-angles-right"></i>Private Cab</li>
                          <li><i className="fa-solid fa-angles-right"></i>Shikara Ride 
                          Houseboat stay in Dal Lake</li>
                        </ul>
                      </div>
                        <hr/>
                        <div className="price">
                        <span className='starts-from'>Starts from</span><br />
                        <span className="old">₹ 28,500</span> 
                        <span className="new">₹ 17500 </span><span>/Person ( Ex - sikkim )</span>
                        </div>

                        <div className="buttons">
                        <button
                        className="book"
                        onClick={() => window.open("https://wa.me/919796840001", "_blank")}
                      >
                         <i className="fab fa-whatsapp"></i>Whatsapp Now
                      </button>

                      <button
                        className="book"
                        onClick={() => (window.location.href = "tel:9796840001")}
                      ><i className="fas fa-phone-alt"></i> Call Now
                      </button>
                        <button className="enquire"  onClick={() => handleShow("Bond, Laugh, Explore: Kashmir Group Special – 5 Nights of Bliss")}><i className="fas fa-envelope"></i>Enquiry</button>
                        </div>
                    </div>
                    </div>
                </div>
                <div className='col-md-6 col-lg-4'>
                <div className="card">
                    <div className="relative">
                        <span className="tag">Best Selling Package
                          <span className='afb'></span>
                        </span>
                        <img className="main-img" src="img/photo-1704991754173-46b72b237e8e.avif" alt="Ladakh Tour" />
                        <div className="duration"><i className="fa-regular fa-clock me-2"></i> Duration: 5 Night 6 days</div>
                    </div>
                    <div className="card-content">
                        <div className="title">sikkim Unplugged: Beyond the Postcard : 6 Days sikkim Offbeat </div>
                        <div className="places"><i className="fa-solid fa-location-dot me-2"></i> Srinagar(2N) | Wular Lake (1N) | Gurez Valley (5N)</div>
                        <hr/>
                        <div className="features">
                        <div><img src="img/binoculars_7006898.png" alt="Safety" />Sightseeing</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/hotel.webp" alt="Hotels" />Hotels</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/meal.webp" alt="Food" />Food</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/car.webp" alt="Transfers" />Transfers</div>
                        </div>
                        <hr/>
                        <div className="package-inclusion">
                        <h4>Package Inclusion:</h4>
                        <ul className="scrollable-list">
                          <li><i className="fa-solid fa-angles-right"></i>Pickup & Drop</li>
                          <li><i className="fa-solid fa-angles-right"></i>Food</li>
                          <li><i className="fa-solid fa-angles-right"></i>Sightseeing</li>
                          <li><i className="fa-solid fa-angles-right"></i>Private Cab</li>
                          <li><i className="fa-solid fa-angles-right"></i>Shikara Ride 
                       Houseboat stay in Dal Lake </li>
                        </ul>
                      </div>
                        <hr/>
                        <div className="price">
                        <span className='starts-from'>Starts from</span><br />
                        <span className="old">₹ 32,100</span> 
                        <span className="new">₹ 29,600</span><span>/Person ( Ex - sikkim )</span>
                        </div>

                        <div className="buttons">
                        <button
                        className="book"
                        onClick={() => window.open("https://wa.me/919796840001", "_blank")}
                      >
                         <i className="fab fa-whatsapp"></i>Whatsapp Now
                      </button>

                      <button
                        className="book"
                        onClick={() => (window.location.href = "tel:9796840001")}
                      ><i className="fas fa-phone-alt"></i> Call Now
                      </button>
                        <button className="enquire" onClick={() => handleShow("Kashmir Unplugged: Beyond the Postcard : 6 Days Kashmir Offbeat")}><i className="fas fa-envelope"></i>Enquiry</button>
                        </div>
                    </div>
                    </div>
                </div>
                <div className='col-md-6 col-lg-4'>
                <div className="card">
                    <div className="relative">
                        <span className="tag">Best Selling Package
                          <span className='afb'></span>
                        </span>
                        <img className="main-img" src="img/photo-1624725412168-a8e69d4f7b36.avif" alt="Ladakh Tour" />
                        <div className="duration"><i className="fa-regular fa-clock me-2"></i> Duration: 7 Night 8 days</div>
                    </div>
                    <div className="card-content">
                        <div className="title">The sikkim You Didn’t Know </div>
                        <div className="places"><i className="fa-solid fa-location-dot me-2"></i> Srinagar(6N) | Kokernag (1N) | Ahrabal Day trip | Yusmarg day trip | Bangus Valley day trip | Verinag & Achabal  Day trip | 
                        </div>
                        <hr/>
                        <div className="features">
                        <div><img src="img/binoculars_7006898.png" alt="Safety" />Sightseeing</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/hotel.webp" alt="Hotels" />Hotels</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/meal.webp" alt="Food" />Food</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/car.webp" alt="Transfers" />Transfers</div>
                        </div>
                        <hr/>
                        <div className="package-inclusion">
                        <h4>Package Inclusion:</h4>
                        <ul className="scrollable-list">
                          <li><i className="fa-solid fa-angles-right"></i>Pickup & Drop</li>
                          <li><i className="fa-solid fa-angles-right"></i>Food</li>
                          <li><i className="fa-solid fa-angles-right"></i>Sightseeing</li>
                          <li><i className="fa-solid fa-angles-right"></i>Private Cab</li>
                          <li><i className="fa-solid fa-angles-right"></i> Shikara Ride 
                       Houseboat stay in Dal Lake </li>
                        </ul>
                      </div>
                        <hr/>
                        <div className="price">
                        <span className='starts-from'>Starts from</span><br />
                        <span className="old">₹ 26,000</span> 
                        <span className="new">₹ 24,000</span><span>/Person (sikkim)</span>
                        </div>

                        <div className="buttons">
                        <button
                        className="book"
                        onClick={() => window.open("https://wa.me/919796840001", "_blank")}
                      >
                         <i className="fab fa-whatsapp"></i>Whatsapp Now
                      </button>

                      <button
                        className="book"
                        onClick={() => (window.location.href = "tel:9796840001")}
                      ><i className="fas fa-phone-alt"></i> Call Now
                      </button>
                        <button className="enquire"onClick={() => handleShow("Wild, Wistful, and Untamed: The Kashmir You Didn't Know")}><i className="fas fa-envelope"></i>Enquiry</button>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section className='best-package pt-4 pb-4'> 
        <div className='text-center package-title'>
            <h2>Himachal Holiday Packages </h2>
            <h6>Experience Himachal like never before with <br/><span className='color-1'>Rizztourandtravels</span></h6>
        </div>
        <div className='container pt-3'>
            <div className='row gy-4'>
            <div className='col-md-6 col-lg-4'>
                <div className="card">
                    <div className="relative">
                        <span className="tag">Best Selling Package
                          <span className='afb'></span>
                        </span>
                        <img className="main-img" src="img/Himachal.jpeg" alt="Ladakh Tour" />
                        <div className="duration"><i className="fa-regular fa-clock me-2"></i> Duration: 4 Night 5 days</div>
                    </div>
                    <div className="card-content">
                        <div className="title">Blissful Manali</div>
                        <div className="places"><i className="fa-solid fa-location-dot me-2"></i> Places to visit Shimla, Manali, Rothang Pass, Solang, Atal Tunnel</div>
                        <hr/>
                        <div className="features">
                        <div><img src="img/binoculars_7006898.png" alt="Safety" />Sightseeing</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/hotel.webp" alt="Hotels" />Hotels</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/meal.webp" alt="Food" />Food</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/car.webp" alt="Transfers" />Transfers</div>
                        </div>
                        <hr/>
                        <div className="package-inclusion">
                        <h4>Package Inclusion:</h4>
                        <ul className="scrollable-list">
                          <li><i className="fa-solid fa-angles-right"></i>Pickup & Drop</li>
                          <li><i className="fa-solid fa-angles-right"></i>Food</li>
                          <li><i className="fa-solid fa-angles-right"></i>Sightseeing</li>
                          <li><i className="fa-solid fa-angles-right"></i>Private Cab</li>
                          <li><i className="fa-solid fa-angles-right"></i>Shikara Ride 
                          Houseboat stay in Dal Lake</li>
                        </ul>
                      </div>
                        <hr/>
                        <div className="price">
                        <span className='starts-from'>Starts from</span><br />
                        <span className="old">₹ 28,500</span> 
                        <span className="new">₹ 15,000 </span><span>/Person ( Ex - Manali )</span>
                        </div>

                        <div className="buttons">
                        <button
                        className="book"
                        onClick={() => window.open("https://wa.me/919796840001", "_blank")}
                      >
                         <i className="fab fa-whatsapp"></i>Whatsapp Now
                      </button>

                      <button
                        className="book"
                        onClick={() => (window.location.href = "tel:9796840001")}
                      ><i className="fas fa-phone-alt"></i> Call Now
                      </button>
                        <button className="enquire"  onClick={() => handleShow("Bond, Laugh, Explore: Kashmir Group Special – 5 Nights of Bliss")}><i className="fas fa-envelope"></i>Enquiry</button>
                        </div>
                    </div>
                    </div>
                </div>
                <div className='col-md-6 col-lg-4'>
                <div className="card">
                    <div className="relative">
                        <span className="tag">Best Selling Package
                          <span className='afb'></span>
                        </span>
                        <img className="main-img" src="img/Himachal3.jpeg" alt="Ladakh Tour" />
                        <div className="duration"><i className="fa-regular fa-clock me-2"></i> Duration: 5 Night 6 days</div>
                    </div>
                    <div className="card-content">
                        <div className="title">Romantic Himachal </div>
                        <div className="places"><i className="fa-solid fa-location-dot me-2"></i> Places to visit Shimla, Manali, kullu, Rothang Pass, Solang, Atal Tunnel</div>
                        <hr/>
                        <div className="features">
                        <div><img src="img/binoculars_7006898.png" alt="Safety" />Sightseeing</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/hotel.webp" alt="Hotels" />Hotels</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/meal.webp" alt="Food" />Food</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/car.webp" alt="Transfers" />Transfers</div>
                        </div>
                        <hr/>
                        <div className="package-inclusion">
                        <h4>Package Inclusion:</h4>
                        <ul className="scrollable-list">
                          <li><i className="fa-solid fa-angles-right"></i>Pickup & Drop</li>
                          <li><i className="fa-solid fa-angles-right"></i>Food</li>
                          <li><i className="fa-solid fa-angles-right"></i>Sightseeing</li>
                          <li><i className="fa-solid fa-angles-right"></i>Private Cab</li>
                          <li><i className="fa-solid fa-angles-right"></i>Shikara Ride 
                       Houseboat stay in Dal Lake </li>
                        </ul>
                      </div>
                        <hr/>
                        <div className="price">
                        <span className='starts-from'>Starts from</span><br />
                        <span className="old">₹ 32,100</span> 
                        <span className="new">₹ 20,000</span><span>/Person ( Ex - Himachal  )</span>
                        </div>

                        <div className="buttons">
                        <button
                        className="book"
                        onClick={() => window.open("https://wa.me/919796840001", "_blank")}
                      >
                         <i className="fab fa-whatsapp"></i>Whatsapp Now
                      </button>

                      <button
                        className="book"
                        onClick={() => (window.location.href = "tel:9796840001")}
                      ><i className="fas fa-phone-alt"></i> Call Now
                      </button>
                        <button className="enquire" onClick={() => handleShow("Kashmir Unplugged: Beyond the Postcard : 6 Days Kashmir Offbeat")}><i className="fas fa-envelope"></i>Enquiry</button>
                        </div>
                    </div>
                    </div>
                </div>
                <div className='col-md-6 col-lg-4'>
                <div className="card">
                    <div className="relative">
                        <span className="tag">Best Selling Package
                          <span className='afb'></span>
                        </span>
                        <img className="main-img" src="img/Himachal4.jpeg" alt="Ladakh Tour" />
                        <div className="duration"><i className="fa-regular fa-clock me-2"></i> Duration: 7 Night 8 days</div>
                    </div>
                    <div className="card-content">
                        <div className="title">Shimla Manali Combo</div>
                        <div className="places"><i className="fa-solid fa-location-dot me-2"></i>Places to visit Shimla, Manali, kullu, Rothang Pass, Solang, Atal Tunnel
                        </div>
                        <hr/>
                        <div className="features">
                        <div><img src="img/binoculars_7006898.png" alt="Safety" />Sightseeing</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/hotel.webp" alt="Hotels" />Hotels</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/meal.webp" alt="Food" />Food</div>
                        <div><img src="https://myvisionkashmir.com/ladakh-packages/assets/images/icons/car.webp" alt="Transfers" />Transfers</div>
                        </div>
                        <hr/>
                        <div className="package-inclusion">
                        <h4>Package Inclusion:</h4>
                        <ul className="scrollable-list">
                          <li><i className="fa-solid fa-angles-right"></i>Pickup & Drop</li>
                          <li><i className="fa-solid fa-angles-right"></i>Food</li>
                          <li><i className="fa-solid fa-angles-right"></i>Sightseeing</li>
                          <li><i className="fa-solid fa-angles-right"></i>Private Cab</li>
                          <li><i className="fa-solid fa-angles-right"></i> Shikara Ride 
                       Houseboat stay in Dal Lake </li>
                        </ul>
                      </div>
                        <hr/>
                        <div className="price">
                        <span className='starts-from'>Starts from</span><br />
                        <span className="old">₹ 26,000</span> 
                        <span className="new">₹ 18,000</span><span>/Person (Manali)</span>
                        </div>

                        <div className="buttons">
                        <button
                        className="book"
                        onClick={() => window.open("https://wa.me/919796840001", "_blank")}
                      >
                         <i className="fab fa-whatsapp"></i>Whatsapp Now
                      </button>

                      <button
                        className="book"
                        onClick={() => (window.location.href = "tel:9796840001")}
                      ><i className="fas fa-phone-alt"></i> Call Now
                      </button>
                        <button className="enquire"onClick={() => handleShow("Wild, Wistful, and Untamed: The Kashmir You Didn't Know")}><i className="fas fa-envelope"></i>Enquiry</button>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section className='why-choose-us pt-5 pb-5 py-5'>
        <div className='container'>
            <h2 className='text-center'>Why Choose Us</h2>
            <div className='row gy-4 pt-4'>
                <div className='col-lg-3 col-sm-6'>
                    <div className='why-choose-box text-center icon1'>
                        <span className='icon icon11'>
                        <img src='img/icon1.png' alt='...' />
                        </span>
                        <strong className='text-black'>Great Deals</strong>
                        <p>We have exclusive tie-ups with hotels and other vendors, so we get unmatched deals with great discounts for you.</p>
                    </div>
                </div>
                <div className='col-lg-3 col-sm-6'>
                    <div className='why-choose-box text-center icon2'>
                    <span className='icon icon22'>
                        <img src='img/icon2.png' alt='...' />
                    </span>
                    <strong className='text-black'>Tailored Experiences</strong>
                    <p>We craft personalized itineraries for luxury vacations, adventure tours, or cultural trips to fit your interests, budget, and style.</p>
                    </div>
                </div>
                <div className='col-lg-3 col-sm-6'>
                    <div className='why-choose-box text-center icon3'>
                    <span className='icon icon33'>
                        <img src='img/icon3.png' alt='...' />
                        </span>
                        <strong className='text-black'>Local Expertise</strong>
                        <p>Our expert guides and local connections uncover hidden gems, authentic experiences, and must-see attractions missed by tourists.</p>
                    </div>
                </div>
                <div className='col-lg-3 col-sm-6'>
                    <div className='why-choose-box text-center icon4'>
                    <span className='icon icon44'>
                        <img src='img/icon4.png' alt='...' />
                        </span>
                        <strong className='text-black'>Sustainable Tourism</strong>
                        <p>We promote sustainable travel to protect nature, support communities, and ensure your journey leaves a positive impact.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section className='dial-us-back container p-0 mb-5 mt-4' style={{ backgroundImage: "url('img/photo-1646053898889ll.avif')" }}>
        <div className='container dial-container position-relative'>
        <span class="tag tag1 py-1">Instant Booking Get 15% Off
        <span class="afb"></span></span>
            <div className='row g-4 align-items-center'>
                <div className='col-md-9'>
                    <div className='dial-title'>
                        <h2 className='fw-bold'>Unveil the Magic of Himachal's Breathtaking Beauty!</h2>
                    </div>
                </div>
                <div className='col-md-3'>
                <div className="btn-container">
                    <button className="enquiry-btn" onClick={handleShow}>ENQUIRY NOW !</button>
                </div>
                </div>
            </div>
        </div>
    </section>

    <section className="top-tour pt-4 pb-4">
        <div className="container">
          <div className="tour-title text-center mb-4">
            <h2>Top 10 Destinations</h2>
          </div>

          <Carousel responsive={responsive} infinite autoPlay autoPlaySpeed={3000}>
            
            <div className='p-3'>
            <div className="tour-pac-box">
              <img src="img/Uttarakhand12.jpeg" alt="Uttarakhand" />
              <div className="card-title"><span>Uttarakhand</span></div>
            </div>
            </div>
            <div className='p-3'>
            <div className="tour-pac-box">
              <img src="img/Kerala3.jpeg" alt="Kerala " />
              <div className="card-title"><span>Kerala </span></div>
            </div>
            </div>
            <div className='p-3'>
            <div className="tour-pac-box">
              <img src="img/Darjeeling3.jpeg" alt="Darjeeling" />
              <div className="card-title"><span>Darjeeling</span></div>
            </div>
            </div>
           <div className='p-3'>
           <div className="tour-pac-box">
              <img src="img/honimoon2.jpeg" alt="sikkim" />
              <div className="card-title"><span>sikkim </span></div>
            </div>
           </div>
            <div className='p-3'>
            <div className="tour-pac-box">
              <img src="img/Himachal4.jpeg" alt="Himachal" />
              <div className="card-title"><span>Himachal </span></div>
            </div>
            </div>
           
          </Carousel>
        </div>
      </section>
      {/* <section className='container pt-5 pb-4'>
        <div className='text-center top-tour pb-3'>
          <h2>Google Reviews</h2>
          <p>Discover What Others Experienced</p>
        </div>
        <div className='row gy-3'>
          <div className='col-md-3'>
            <div className='left-rev-box'>
            <img class="logo" alt="Logo" src="img/logo.webp"/>
            <img src="https://i0.wp.com/storyteller.co.za/wp-content/uploads/2018/06/How-To-Get-More-Google-Reviews-.png" alt="..." className='google-rev'/>
            </div>
          </div>
          <div className='col-md-9'>
            <div className='reviews'>
            <div
            className="elfsight-app-7e787a50-f3ed-4822-b214-7a86ed7810d4"
            data-elfsight-app-lazy
          ></div>
            </div>
          </div>
        </div>
      </section> */}
    <section className='ask-section pt-4 pb-4'>
        <div className='container'>
            <div className='tour-title text-center pb-3'>
                <h2>Still are you searching?<br/> Your search Ends Here</h2>
            </div>
            <div className='ask-contant'>
            <p>  Hi, if you are searching these keywords on google Uttarakhand  Tour Package, Best Uttarakhand  Tour Packages, Package Tour to Uttarakhand , Kerala  Honeymoon Package, Kerala  Honeymoon Packages, Holiday Package for Himachal , Himachal  Itinerary, Himachal  Travel Plan, Himachal  Family Tour Packages, Tour Package for sikkim, sikkim Tourism Packages, Cheap sikkim Tour Packages, sikkim Travel Packages, Best Tour Operator in sikkim, sikkim Tour and Travels, Darjeeling and sikkim Package, sikkim and Darjeeling  Tour, Couple Packages for Uttarakhand , Holiday Packages Uttarakhand , Himachal  Package Tour, Kerala  Tour Packages, Package for Kerala ,
               Kerala  Package, Travels and many more. 
               <span>Your search Ends Here.</span></p>
           <div className='conntect-now'>
           <h3 className='m-0'>Connect Now 👉</h3>
           <div className="pulse-button" onClick={() => window.open("https://wa.me/919419046560", "_blank")}>
                <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="whatsapp"/>
            </div>
           </div>


            <div className=" plus" id="whatsapp" onClick={() => window.open("https://wa.me/919419046560", "_blank")}>
            <i class="fa-brands fa-whatsapp"></i>
            </div>
            <div className=" plus" id="call" onClick={() => window.open("tel:+919419046560", "_self")}>
            <i class="fa-solid fa-phone-volume"></i>
            </div>


            </div>
        </div>
    </section>
    <section className='Contact-section pt-4 pb-4'>
        <div className='container'>
        <div className='tour-title text-center pb-3'>
                <h2>Contact Us</h2>
            </div>
            <div className='row pt-4'>
                <div className='col-md-7'>
                    <div className='contact-detail'>
                        <h4 className='fw-bold'>Get Customizable Packages</h4>
                        <p>Plan your vacation with our collection of personalized Kashmir tour packages.</p>
                        <div className='contact-list'>
                            <div className='icon-box'>
                            <i className="fa-solid fa-location-pin"></i>
                            </div>
                            <div className='list-detail'>
                                <h5 className='fw-bold'>Office:</h5>
                                <p> M.A.link Road, Shahjee Complex, Munawarabad, Srinagar 190001 Jammu and Kashmir​​​​​</p>
                            </div>
                        </div>
                        <div className='contact-list'>
                            <div className='icon-box'>
                            <i className="fa-solid fa-envelope"></i>
                            </div>
                            <div className='list-detail'>
                                <h5 className='fw-bold'>Email:</h5>
                                <p>holidays@rizztourandtravels.com</p>
                            </div>
                        </div>
                        <div className='contact-list'>
                            <div className='icon-box'>
                            <i className="fa-solid fa-phone"></i>
                            </div>
                            <div className='list-detail'>
                                <h5 className='fw-bold'>Call:</h5>
                                <p>+91 9419046560</p>
                            </div>
                        </div>
                        <div className='contact-list'>
                            <div className='icon-box'>
                            <i className="fa-brands fa-whatsapp"></i>
                            </div>
                            <div className='list-detail'>
                                <h5 className='fw-bold'>WhatsApp:</h5>
                                <p>+91 9419046560</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-md-5'>
                <div className="form-container footer-form">
                    <h2>Talk To Our Expert</h2>
                    <p>For Consultation on Kashmir Holiday Packages !</p>
                      <form method="POST" action="/best-tour-packages-in-india/mail.php">
            <div className="form-group mb-md-3">
              <label htmlFor="name">Full Name</label>
              <input type="text" id="name" required name="name" placeholder="Full Name" className="form-control" />
            </div>
            <div className="form-group mb-0 mb-md-3">
              <label htmlFor="email">Email</label>
              <input type="email" id="email" required name="email" placeholder="Email" className="form-control" />
            </div>
            <div className="d-flex flex-row flex-md-row gap-2 ">
            <div className="form-group flex-fill">
              <label htmlFor="phone">Mobile</label>
              <input type="tel" id="phone" required name="phone" placeholder="Mobile" className="form-control" />
            </div>
              <div className="form-group flex-fill">
                <label htmlFor="nop">No of Persons</label>
                <input type="number" id="nop" required name="nop" placeholder="No of Persons" className="form-control" />
              </div>
              </div>
              <div className="d-flex flex-row flex-md-row gap-2">
              <div className="form-group flex-fill">
                <label htmlFor="travel_date">Travel Date</label>
                <input type="date" id="travel_date" required name="travel_date" placeholder="dd/mm/yyyy" className="form-control" />
              </div>
              <div className="form-group flex-fill">
                <label htmlFor="city">City</label>
                <input type="text" id="city" required name="city" placeholder="City" className="form-control" />
              </div>
            </div>
            <button type="submit" className="btn btn-primary w-100">Send Enquiry</button>
          </form>
                </div>
                </div>
            </div>
        </div>
    </section>
    {showModal && (
        <div className="modal-overlay" onClick={handleClose}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <button className="close-button" onClick={handleClose}>
              &times;
            </button>
            <div className="form-container last-form">
            <span className="tag">Instant Booking Get 15% Off
                          <span className='afb'></span>
                        </span>
              <h2>Talk To Our Expert</h2>
              <p>For Consultation on Utrakhand Holiday Packages!</p>
              <form method="POST" action="/best-tour-packages-in-india/mail.php">
              <input type="hidden" name="package" value={selectedPackage} />
            <div className="form-group mb-0 mb-md-3">
              <label htmlFor="name">Full Name</label>
              <input type="text" id="name" required name="name" placeholder="Full Name" className="form-control" />
            </div>
            <div className="form-group mb-md-3">
              <label htmlFor="email">Email</label>
              <input type="email" id="email" required name="email" placeholder="Email" className="form-control" />
            </div>
            <div className="d-flex flex-row flex-md-row gap-2">
            <div className="form-group flex-fill">
              <label htmlFor="phone">Mobile</label>
              <input type="tel" id="phone" required name="phone" placeholder="Mobile" className="form-control" />
            </div>
              <div className="form-group flex-fill">
                <label htmlFor="nop">No of Persons</label>
                <input type="number" id="nop" required name="nop" placeholder="No of Persons" className="form-control" />
              </div>
              </div>
              <div className="d-flex flex-row flex-md-row gap-2 ">
              <div className="form-group flex-fill">
                <label htmlFor="travel_date">Travel Date</label>
                <input type="date" id="travel_date" required name="travel_date" placeholder="dd/mm/yyyy" className="form-control" />
              </div>
              <div className="form-group flex-fill">
                <label htmlFor="city">City</label>
                <input type="text" id="city" name="city" required placeholder="City" className="form-control" />
              </div>
            </div>
            <button type="submit" className="btn btn-primary w-100">Send Enquiry</button>
          </form>
            </div>
          </div>
        </div>
        )}

      {/* Add these styles to your CSS */}
      <style jsx>{`
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.7);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
        }
        
        .modal-content {
          background: white;
          padding: 30px;
          border-radius: 10px;
          position: relative;
          max-width: 500px;
          width: 90%;
          max-height: 90vh;
          overflow-y: auto;
        }
        
        .close-button {
          position: absolute;
          top: 10px;
          right: 15px;
          font-size: 24px;
          border: none;
          background: none;
          cursor: pointer;
          color: #666;
        }
        
        .close-button:hover {
          color: #000;
        }
        
        /* Add any additional styling you need for the form */
      `}</style>
    </div>
    
  );
}